
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { emptyToLine, splitThousands } from "@/utils/common";
import { Table } from "@/utils/decorator";
import dayjs from "dayjs";
import t from "@common/src/i18n/t";
const service = namespace("service");
const base = namespace("base");
const staff = namespace("staff");
const testingItem = namespace("testing-item");
const setting = namespace("setting");
const management = namespace("management");

@Component({})
@Table("loadListData")
export default class ServiceList extends Vue {
  dayjs = dayjs;
  @testingItem.Action getTestOrderDetail;
  @testingItem.Action getTestOrdeList;
  @testingItem.Action getTestingTemplateList;
  @service.Action onlineVerificationCode;
  @service.Action completeOrder;
  @base.Action getDictionaryList;
  @staff.Action getStaffList;
  @management.Action getStoreList;
  emptyToLine = emptyToLine;
  splitThousands = splitThousands;
  orderList: any[] = [];
  showPickingTips: boolean = false;
  searchForm = {
    orderTimeEnd: "",
    orderTimeStart: "",
    orderStatus: "",
    technicianCode: "",
    searchKey: "",
    templateCode: "",
    storeCode: ""
  };
  orderStatus: any = "";
  testTemplateList: any[] = [];
  // 添加报告预览相关的数据
  reportDialogVisible: boolean = false;
  reportUrl: string = "";
  isFullscreen: boolean = false;
  // 展开行相关
  expandRowKeys: string[] = [];
  testOrderDetail = [];

  created() {
    this.loadListData();
    this.init();
  }

  init() {
    // 订单状态字典List
    this.getDictionaryList("check_order_status").then(data => {
      this.orderStatus = data;
    });
    // 模板列表
    // this.getTestingTemplateList({
    //   pageNum: this.mix_pageNum,
    //   pageSize: 999
    // }).then(data => {
    //   this.testTemplateList = data.data.list.map(item => ({
    //     label: item.checkTemplateName,
    //     value: item.checkTemplateCode
    //   }));
    // });
    // 员工和顾问 List
    // this.getStaffList({
    //   pageSize: 999,
    //   pageNum: 1
    // }).then(data => {
    //   const staffList = this.$safeValue(data, "data.list", []).map(item => ({
    //     label: item.staffName,
    //     value: item.userCode
    //   }));
    //   this.staffList = staffList;
    // });
  }

  @Table.LoadDataMethod()
  loadListData() {
    return this.getTestOrdeList({
      ...this.searchForm,
      pageNum: this.mix_pageNum,
      pageSize: this.mix_pageSize
    }).then(data => {
      this.orderList = data.data.list;
      return data;
    });
  }

  staffList: any[] = [];
  storeList: any = [];

  get searchList() {
    return [
      {
        label: t("test.keyword"),
        type: "input",
        value: "",
        prop: "searchKey",
        placeholder: t("test.license-name-mobile-vincode")
      },
      {
        label: this.$t("staff.store"),
        type: "select-search",
        value: "",
        prop: "storeCode",
        selectList: this.storeList,
        searchFun: this.searchStore
      },
      {
        label: t("finance.creation-time"),
        type: "daterange",
        value: "",
        prop: "createDate"
      },
      // {
      //   label: t("test.detection-template"),
      //   type: "select",
      //   selectList: this.testTemplateList,
      //   value: "",
      //   prop: "templateCode"
      // },
      // {
      //   label: t("test.service-consultant"),
      //   type: "select",
      //   selectList: this.staffList,
      //   value: "",
      //   prop: "advisorCode"
      // },
      // {
      //   label: t("test.service-technician"),
      //   type: "select",
      //   selectList: this.staffList,
      //   value: "",
      //   prop: "technicianCode"
      // },
      {
        label: t("finance.state"),
        type: "select",
        selectList: this.orderStatus,
        value: "",
        prop: "orderStatus"
      }
    ];
  }

  handleSearch(data) {
    this.mix_pageNum = 1;
    data.forEach(item => {
      if (item.prop) {
        if (item.prop === "createDate") {
          if (item.value) {
            this.searchForm["orderTimeStart"] = item.value[0];
            this.searchForm["orderTimeEnd"] = item.value[1];
          } else {
            this.searchForm["orderTimeStart"] = "";
            this.searchForm["orderTimeEnd"] = "";
          }
        } else if (item.prop === "orderStatus") {
          this.searchForm[item.prop] = item.value ? item.value : "";
        } else {
          this.searchForm[item.prop] = item.value;
        }
      }
    });
    this.loadListData();
  }

  handleView(row) {
    let { href } = this.$router.resolve({
      path: `/test/view/${row.checkOrderNo}`
    });
    window.open(href, "_blank");
  }

  handleViewServiceOrder(row) {
    let { href } = this.$router.resolve({
      path: `/service/view/${row.serviceOrderNo}?tenantCode=${row.tenantCode}`
    });
    window.open(href, "_blank");
  }

  searchStore(val = "") {
    this.getStoreList({
      pageNum: 1,
      pageSize: 10,
      storeName: val
    }).then(data => {
      this.storeList = data.data.list
        ? data.data.list.map(item => {
          item.label = item.storeName;
          item.value = item.storeCode;
          return item;
        })
        : [];
    });
  }

  handleUserView(row) {
    let { href } = this.$router.resolve({
      path: `/customer/customer-view/${row.customerMobile}`
    });
    window.open(href, "_blank");
  }

  handleRowClick(row, column, event) {
    this.getTestOrderDetail({
      checkOrderNo: row.checkOrderNo
    }).then(data => {
      if (data.data.warningDetails.length <= 0) {
        return;
      }

      this.testOrderDetail = data.data.warningDetails

      //  数据请求成功后，再展开
      // 避免点击有具体事件的元素时触发行点击
      if (event.target.closest('.el-button') || event.target.closest('.order-no-cell') || event.target.closest('.copy-icon')) {
        return;
      }

      // 切换展开行状态
      const index = this.expandRowKeys.indexOf(row.checkOrderNo);
      if (index > -1) {
        // 如果已经展开，则收起
        this.expandRowKeys.splice(index, 1);
      } else {
        // 如果未展开，则展开
        this.expandRowKeys = [row.checkOrderNo];
      }
    });
  }

  copyToClipboard(text, label) {
    // 复制到剪贴板的实现
    const input = document.createElement('input');
    input.value = text;
    document.body.appendChild(input);
    input.select();
    document.execCommand('copy');
    document.body.removeChild(input);
    // 可以添加复制成功的提示
    this.$message.success(`已复制${label}`);
  }

  // 修改预览报告方法，使用对话框展示
  handleViewCheckDetail(orderNo: string) {
    this.reportUrl = `${process.env.VUE_APP_CHECK_H5_SITE}?orderNo=` + orderNo;
    this.reportDialogVisible = true;
  }

  // 切换全屏/非全屏
  toggleFullScreen() {
    this.isFullscreen = !this.isFullscreen;
  }

  // 关闭对话框前的回调
  handleCloseReportDialog() {
    this.reportDialogVisible = false;
    this.reportUrl = "";
    this.isFullscreen = false;
  }

  // 获取状态对应的样式类
  getStatusClass(status) {
    const statusMap = {
      "2": "status-primary", // 进行中
      "4": "status-success", // 已完成
      "5": "status-warning", // 处理中
      "9": "status-info" // 已取消
    };

    return statusMap[status] || "status-default";
  }

  // 获取状态对应的图标
  getStatusIcon(status) {
    const iconMap = {
      "2": "el-icon-loading",
      "4": "el-icon-check",
      "5": "el-icon-time",
      "9": "el-icon-close"
    };

    return iconMap[status] || "el-icon-info";
  }
}
